var _rect, _path, _path2, _use, _use2, _use3;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgMq(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 750 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 750,
    height: 500,
    fill: "#21428e"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 375,0 V 500 M 0,250 H 750",
    stroke: "#fff",
    strokeWidth: 72.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    id: "path8",
    d: "M 62.3,11.9 C 59.9,13 58,14.6 58,15.4 C 58,16.3 59.4,16.3 57.6,16.9 C 55.9,17.5 51.3,18.3 48.1,18.2 C 47,18.2 44.4,17.5 43.7,17.5 C 42.9,17.6 47.1,19.3 45.5,18.9 C 43.3,18.3 42,18.1 43.7,19.2 C 45,20 47.9,20 52,19.5 C 53.6,19.3 57.8,18.4 59.3,18.2 C 60.3,18.1 60.3,19 60.9,19 C 66.3,19.3 75.9,19.1 80.1,18.5 C 83.6,18 84.9,18.2 85.9,19.4 C 87.9,21.7 85.8,23.7 80.1,24.9 C 73.1,26.4 70.2,27.7 67.5,30.6 C 61,37.6 68.6,45.5 82.8,46.6 C 91.1,47.3 96.5,48.9 95.2,50.2 C 94.7,50.7 89.2,51.5 82.9,52 C 69.2,53.1 63.1,55 57.9,60 C 55,62.8 54,64.5 54,66.8 C 54,70 54,70 48.7,70 C 45.9,70 42,69.6 40.2,69 C 37.4,68.3 37,68.3 38,69.5 C 40,71.9 45.7,74 50.4,74 C 54,74 56,74.7 59.2,77 C 65.6,81.7 72.9,83.5 85,83.4 C 100.9,83.3 110,79.1 110,72 C 110,66.7 104,63.6 91.5,62.5 C 85.2,61.9 72.8,62.9 67.4,64.5 C 66.4,64.8 67.5,64.1 69.9,62.9 C 72.8,61.5 77.6,60.5 84.1,59.9 C 98.5,58.7 105,55.5 105,49.5 C 105,43.7 98.6,40.4 84.9,39.1 C 71.4,37.9 70.4,35.5 81.8,32 C 89.9,29.6 94,26 94,21.1 C 94,13.6 89.9,11.1 76.2,10.4 C 67.9,10 65.9,10.2 62.3,11.9 z M 69.5,14 C 69.2,14.5 68.4,15 67.9,15 C 67.3,15 67.2,14.5 67.5,14 C 67.8,13.4 68.6,13 69.1,13 C 69.7,13 69.8,13.4 69.5,14 z M 98.4,70 C 100.3,70.7 101,71.4 100.4,72 C 98.7,73.7 87.7,75.2 81,74.7 C 73.6,74 65.6,71.6 68,70.6 C 74.7,68 92.3,67.7 98.4,70 z",
    transform: "scale(2.3)",
    fill: "#fff"
  })), _use || (_use = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8",
    x: 411.25
  })), _use2 || (_use2 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8",
    y: 286.25
  })), _use3 || (_use3 = /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path8",
    x: 411.25,
    y: 286.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMq);
export default __webpack_public_path__ + "static/media/mq.9f64a5ddae1c43fa3c9383ff5a95c750.svg";
export { ForwardRef as ReactComponent };